import React from "react";
import { RefundRequest } from "../../../common/types";
import {
  Table,
  TableBody,
  TableHeaderItem,
  TableHeaders,
} from "@glamcorner/components/lib/core/components/Table/Table";
import { calcRequestTotal, formatDateTime, refundType, summarizeChecklist } from "../../utils";
import "./refund-request-table.scss";
import { RefundRequestStatus } from "../RefundRequestStatus";
import { RefundInDays } from "../RefundInDays";

export interface RefundRequestTableProps {
  refundRequests: RefundRequest[];
  onTableRowClick: (id: string) => void;
}

export const RefundRequestTable: React.FC<RefundRequestTableProps> = ({ refundRequests, onTableRowClick }) => {
  const headers: TableHeaderItem[] = [
    { align: "left", text: "Created At" },
    { align: "left", text: "Order Id" },
    { align: "left", text: "Name" },
    { align: "left", text: "Email" },
    { align: "left", text: "Status" },
    { align: "left", text: "Reason" },
    { align: "left", text: "Type" },
    { align: "right", text: "Amount" },
    { align: "right", text: "Refund in # days" },
    { align: "right", text: "Checklist" },
  ];

  const handleClick = (id: string) => {
    if (onTableRowClick) {
      onTableRowClick(id);
    }
  };

  const tdStyleClass = (request: RefundRequest, ...styleClasses: string[]) => {
    const result = [...styleClasses];
    result.push("c-refund-requests-table__td");
    if (request.deletedAt) {
      result.push("c-refund-requests-table__td-strike");
    }
    return result.join(" ");
  };

  return (
    <Table className="c-refund-requests-table">
      <TableHeaders items={headers} />
      <TableBody className="c-refund-requests-table__body">
        {refundRequests.map((request: RefundRequest) => {
          return (
            <tr
              key={request.id}
              onClick={() => {
                handleClick(request.id);
              }}
            >
              <td className={tdStyleClass(request)}>{formatDateTime(request.createdAt)}</td>
              <td className={tdStyleClass(request)}>{request.orderId}</td>
              <td className={tdStyleClass(request)}>{request.customerName}</td>
              <td className={tdStyleClass(request)}>{request.customerEmail}</td>
              <td className={tdStyleClass(request)} style={{ width: 200 }}>
                <RefundRequestStatus status={request.status} />
              </td>
              <td className={tdStyleClass(request)}>{request.refundReason}</td>
              <td className={tdStyleClass(request)}>{refundType(request)}</td>
              <td className={tdStyleClass(request, "c-table__cell--right")}>{calcRequestTotal(request.components)}</td>
              <td className={tdStyleClass(request, "c-table__cell--right")}>
                <RefundInDays refundRequest={request} />
              </td>
              <td className={tdStyleClass(request, "c-table__cell--right")}>
                {summarizeChecklist(request.checklistItems)}
              </td>
            </tr>
          );
        })}
      </TableBody>
    </Table>
  );
};
